import React from "react";

export function LabelSelectUcIconeGestor(props) {
    //no individual exibe se tem id selecionado no select
    let nome = props.text || "Unidade Consumidora";
    let condicaoExibicaoIcone = props.filtro.id_unidade_consumidora;
    let idUc = props.filtro.id_unidade_consumidora;

    //no multi exibe se tive uma unica uc no filtro
    if (props.isMulti) {
        nome = props.text || "Unidades Consumidoras";
        condicaoExibicaoIcone = props.filtro.unidades_consumidoras.length == 1;
        idUc = (props.filtro.unidades_consumidoras[0] || {}).value;
    }

    return (
        <div className="d-flex" title="Visualizar dados do contato da concessionária desta UC">
            <div className="mr-2">{nome}</div>
            {condicaoExibicaoIcone ? (
                <div
                    className="position-relative"
                    style={{ height: 20 }}
                    onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        const ucFiltro = props.listaUnidadeConsumidora.find((uc) => uc.id == idUc);
                        if (!ucFiltro || (!ucFiltro.gestor_concessionaria_energia && !ucFiltro.gestor_concessionaria_agua)) {
                            return window.alert("Ainda não há um contato definido para a unidade selecionada");
                        }

                        props.setExibirModal(ucFiltro);
                    }}
                >
                    <i style={{ fontSize: "1.2rem", "--bg": "#ffffff", "--fg": "#000000;" }} className="fas fa-id-badge inverter-hover"></i>
                    <i style={{ fontSize: "0.7rem", paddingLeft: 4, color: "#009dff", position: "absolute", top: -4, right: -12 }} className="fas fa-info-circle"></i>
                </div>
            ) : null}
        </div>
    );
}
